export const DEFAULT_CONNECTOR_COLOR = '#666666';
const SELECTED_CONNECTOR_COLOR = '#0096FA';
export class JsPlumbService {
    createInstance(canvas) {
        const plumbInstance = {
            Endpoint: ['Dot', { radius: 15 }],
            endpointStyle: { fill: 'transparent' },
            Connector: 'Flowchart',
            ConnectionOverlays: [
                [
                    'Arrow',
                    {
                        location: 1,
                        id: 'arrow',
                        length: 10,
                    },
                ],
            ],
            Container: 'diagramContainer',
        };
        const instance = jsPlumb.getInstance(plumbInstance);
        instance.registerConnectionTypes({
            basic: {
                paintStyle: { stroke: DEFAULT_CONNECTOR_COLOR, strokeWidth: 2 },
                hoverPaintStyle: { stroke: DEFAULT_CONNECTOR_COLOR, strokeWidth: 2 },
                cssClass: 'connector-normal',
            },
            selected: {
                paintStyle: { stroke: SELECTED_CONNECTOR_COLOR, strokeWidth: 2 },
                hoverPaintStyle: { stroke: SELECTED_CONNECTOR_COLOR, strokeWidth: 2 },
                cssClass: 'connector-selected',
            },
        });
        instance.bind('click', (el) => {
            const handleKeyPressed = (event) => {
                if (!el._jsPlumb) {
                    return;
                }
                if (event.code === 'Delete') {
                    el.toggleType('selected');
                    instance.deleteConnection(el);
                    window.removeEventListener('keydown', handleKeyPressed, true);
                    canvas.removeEventListener('click', removeConnectionsKeyListeners, true);
                }
            };
            const removeConnectionsKeyListeners = (event) => {
                el.toggleType('selected');
                window.removeEventListener('keydown', handleKeyPressed, true);
                canvas.removeEventListener('click', removeConnectionsKeyListeners, true);
            };
            el.toggleType('selected');
            if (el.hasType('selected')) {
                canvas.addEventListener('click', removeConnectionsKeyListeners, true);
                window.addEventListener('keydown', handleKeyPressed, true);
            }
            else {
                window.removeEventListener('keydown', handleKeyPressed, true);
                canvas.removeEventListener('click', removeConnectionsKeyListeners, true);
            }
        });
        return instance;
    }
}
